Ember.O = function(properties) {
    return Ember.Object.detectInstance(properties) ? properties : Ember.Object.create(properties)
}
